var map = {
	"./de-at.svg": "4PNB",
	"./de-ch.svg": "xMgk",
	"./de.svg": "GJsl",
	"./en-au.svg": "XLfH",
	"./en-gb.svg": "LKE1",
	"./en-us.svg": "NdZX",
	"./es.svg": "Z2cF",
	"./fr.svg": "rc8a",
	"./it.svg": "36ka"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z38B";